import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Organization } from "@/hooks/useOrganizations";
import OrganizationsMultiSelect from "@/components/v2/molecules/admin/tabs/AdminDashboardTab/OrganizationsMultiSelect";
import { Search, X } from "lucide-react";

interface PropertiesFiltersProps {
  searchTerm: string;
  selectedOrganizations: string[];
  availabilityFilter: string;
  onSearchChange: (value: string) => void;
  onOrganizationsChange: (value: string[]) => void;
  onAvailabilityChange: (value: string) => void;
  organizations: Organization[];
  hasActiveFilters: boolean;
  onClearFilters: () => void;
}

const PropertiesFilters = ({
  searchTerm,
  selectedOrganizations,
  availabilityFilter,
  onSearchChange,
  onOrganizationsChange,
  onAvailabilityChange,
  organizations,
  hasActiveFilters,
  onClearFilters,
}: PropertiesFiltersProps) => (
  <div className="flex items-center justify-between gap-4 flex-wrap">
    <div className="flex items-center gap-2">
      <div className="relative">
        <Search className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Buscar propiedad..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-9 w-[200px] rounded-full bg-muted/50 hover:bg-muted transition-colors border-0 h-10"
        />
      </div>

      <OrganizationsMultiSelect
        organizations={organizations}
        selectedOrganizations={selectedOrganizations}
        onSelectionChange={onOrganizationsChange}
      />

      <Select value={availabilityFilter} onValueChange={onAvailabilityChange}>
        <SelectTrigger className="w-[180px] rounded-full bg-muted/50 hover:bg-muted transition-colors border-0">
          <SelectValue placeholder="Todas las propiedades" />
        </SelectTrigger>
        <SelectContent className="bg-background z-50">
          <SelectItem value="all">Todas</SelectItem>
          <SelectItem value="available">Disponibles</SelectItem>
          <SelectItem value="unavailable">No disponibles</SelectItem>
          <SelectItem value="featured">Destacadas</SelectItem>
        </SelectContent>
      </Select>
    </div>

    {hasActiveFilters && (
      <Button
        variant="ghost"
        size="icon"
        onClick={onClearFilters}
        className="h-10 w-10 rounded-full bg-muted/50 hover:bg-muted transition-colors"
      >
        <X className="h-4 w-4" />
      </Button>
    )}
  </div>
);

export default PropertiesFilters;
